import { render, staticRenderFns } from "./createNewUser.vue?vue&type=template&id=426f040e"
import script from "./createNewUser.vue?vue&type=script&lang=js"
export * from "./createNewUser.vue?vue&type=script&lang=js"
import style0 from "./createNewUser.vue?vue&type=style&index=0&id=426f040e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports